module.exports = __webpack_public_path__ + "static/media/20.0a4a5ff2.jpeg";